import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import AdviserProfileInvestmentMinimums from '../../../common/AdviserProfiles/AdviserProfileInvestmentMinimums'
import * as styles from './_AdviserProfileInvestmentMinimumsEditor.scss'
import FieldGroup from '../../../common/forms/FieldGroup'
import { connect } from 'react-redux'
import { actions, minimumLumpSumSelected, minimumMonthlyDebitOrderSelected } from './adviserProfileInvestmentMinimumsEditorActions'
import { bindActionCreators } from 'redux'
import {FormCheck} from 'react-bootstrap'
import {formatToRandsWithoutSymbol} from '../../../common/formatters'
import PropTypes from 'prop-types';

class AdviserProfileInvestmentMinimumsEditor extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editing: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditing: PropTypes.func.isRequired,
    stopEditing: PropTypes.func.isRequired,
    setMinimumLumpSum: PropTypes.func.isRequired,
    setMinimumMonthlyDebitOrder: PropTypes.func.isRequired,
    setAllowUnsureInvestors: PropTypes.func.isRequired,
    cancelEditingAdviserProfileInvestmentMinimums: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    minimumLumpSumSelected: PropTypes.func.isRequired,
    minimumMonthlyDebitOrderSelected: PropTypes.func.isRequired,
    onChange: PropTypes.func
  };

  constructor (props) {
    super(props)

    this.state = { isEditingMinimumLumpSum: false }
    this.state = { isEditingMinimumMonthlyDebitOrder: false }
    this.state = { unformattedMinimumLumpSum: 0 }
    this.state = { unformattedMinimumMonthlyDebitOrder: 0 }

    this.renderPreview = this.renderPreview.bind(this)
    this.renderEditor = this.renderEditor.bind(this)
    this.toggleEditingMinimumLumpSumChange = this.toggleEditingMinimumLumpSumChange.bind(this)
    this.toggleEditingMinimumMonthlyDebitOrderChange = this.toggleEditingMinimumMonthlyDebitOrderChange.bind(this)
    this.handleToggleAllowUnsureInvestors = this.handleToggleAllowUnsureInvestors.bind(this)
    this.onMinimumLumpSumChanged = this.onMinimumLumpSumChanged.bind(this)
    this.onMinimumMonthlyDebitOrderChanged = this.onMinimumMonthlyDebitOrderChanged.bind(this)
  }

  componentDidMount () {
    if (this.props.profile && this.props.profile.investmentMinimums && this.props.profile.investmentMinimums.minimumLumpSum) {
      this.setState({ unformattedMinimumLumpSum: this.props.profile.investmentMinimums.minimumLumpSum })
    }

    if (this.props.profile && this.props.profile.investmentMinimums && this.props.profile.investmentMinimums.minimumMonthlyDebitOrder) {
      this.setState({ unformattedMinimumMonthlyDebitOrder: this.props.profile.investmentMinimums.minimumMonthlyDebitOrder })
    }
  }

  renderPreview () {
    return <AdviserProfileInvestmentMinimums investmentMinimums={this.props.profile.investmentMinimums} />
  }

  toggleEditingMinimumLumpSumChange () {
    if (this.state.isEditingMinimumLumpSum) {
      // Leaving the field: persist whatever the user typed (or cleared).
      this.props.setMinimumLumpSum(this.state.unformattedMinimumLumpSum)
      this.setState({ isEditingMinimumLumpSum: false })
    } else {
      // Entering the field: seed it with the current value so an existing amount isn't wiped on
      // focus. The user can then edit or clear it themselves.
      this.setState({
        isEditingMinimumLumpSum: true,
        unformattedMinimumLumpSum: this.props.profile.investmentMinimums?.minimumLumpSum
      })
    }
  }

  toggleEditingMinimumMonthlyDebitOrderChange () {
    if (this.state.isEditingMinimumMonthlyDebitOrder) {
      this.props.setMinimumMonthlyDebitOrder(this.state.unformattedMinimumMonthlyDebitOrder)
      this.setState({ isEditingMinimumMonthlyDebitOrder: false })
    } else {
      this.setState({
        isEditingMinimumMonthlyDebitOrder: true,
        unformattedMinimumMonthlyDebitOrder: this.props.profile.investmentMinimums?.minimumMonthlyDebitOrder
      })
    }
  }

  handleToggleAllowUnsureInvestors (value) {
    this.props.setAllowUnsureInvestors(value)
  }

  onMinimumLumpSumChanged = (event) => {
    const parsed = parseInt(event.target.value, 10)
    // Cleared/invalid -> 0 (NOT NULL columns, so never persist null/empty and crash the draft save).
    // A WIP draft may hold 0; a real minimum (> 0) is required only at Submit-for-approval
    // (validateProfileForApproval), like every other mandatory field. Negatives clamp to 0.
    this.setState({ unformattedMinimumLumpSum: isNaN(parsed) ? 0 : Math.max(0, parsed) })
  }

  onMinimumMonthlyDebitOrderChanged = (event) => {
    const parsed = parseInt(event.target.value, 10)
    this.setState({ unformattedMinimumMonthlyDebitOrder: isNaN(parsed) ? 0 : Math.max(0, parsed) })
  }

  onChange (event) {
    this.props.onChange(event.target.value)
  }

  renderEditor () {
    const validationstate = this.props.validationstate
    const profile = this.props.profile
    const allowUnsureInvestors = profile.investmentMinimums ? profile.investmentMinimums.allowUnsureInvestors : false

    return <form className={styles['form-bottom-margin']}>
      <h4 className={styles['title']}>Investment Minimums</h4>
      {this.state.isEditingMinimumLumpSum ? (
        <FieldGroup
          required
          label='Minimum lump sum'
          type={'number'}
          prefix={'R'}
          value={this.state.unformattedMinimumLumpSum || ''}
          onChange={this.onMinimumLumpSumChanged}
          message={validationstate.minimumLumpSum.message}
          isInvalid={validationstate.minimumLumpSum.isInvalid}
          onWheel={event => { event.preventDefault() }}
          onBlur={this.toggleEditingMinimumLumpSumChange}
          />
          ) : (
            <FieldGroup
              required
              label='Minimum lump sum'
              type={'text'}
              prefix={'R'}
              value={formatToRandsWithoutSymbol(this.props.profile.investmentMinimums?.minimumLumpSum)}
              message={validationstate.minimumLumpSum.message}
              onChange={() => {}}
              isInvalid={validationstate.minimumLumpSum.isInvalid}
              onWheel={event => {}}
              onFocus={this.toggleEditingMinimumLumpSumChange}
      />
      )}
      {this.state.isEditingMinimumMonthlyDebitOrder ? (
        <FieldGroup
          required
          label='Minimum monthly debit order'
          type={'number'}
          prefix={'R'}
          value={this.state.unformattedMinimumMonthlyDebitOrder || ''}
          onChange={this.onMinimumMonthlyDebitOrderChanged}
          message={validationstate.minimumMonthlyDebitOrder.message}
          isInvalid={validationstate.minimumMonthlyDebitOrder.isInvalid}
          onWheel={event => { event.preventDefault() }}
          onBlur={this.toggleEditingMinimumMonthlyDebitOrderChange}
       />
      ) : (
        <FieldGroup
          required
          label='Minimum monthly debit order'
          type={'text'}
          prefix={'R'}
          value={formatToRandsWithoutSymbol(this.props.profile.investmentMinimums?.minimumMonthlyDebitOrder)}
          message={validationstate.minimumMonthlyDebitOrder.message}
          onChange={() => {}}
          isInvalid={validationstate.minimumMonthlyDebitOrder.isInvalid}
          onWheel={event => {}}
          onFocus={this.toggleEditingMinimumMonthlyDebitOrderChange}
       />
      )}
      <FormCheck
        type="checkbox"
        className={styles['inline-block'] || ''}
        checked={allowUnsureInvestors}
        onChange={() => {
          this.handleToggleAllowUnsureInvestors(!allowUnsureInvestors)
        }}
        label="I am willing to work with investors who are unsure how much they would like to invest."
      />

    </form>
  }

  render () {
    if (this.props.editing) {
      return this.renderEditor()
    }
    return this.renderPreview()
  }
}

const mapStateToProps = (state) => {
  return {
    editing: state.adviserProfileEditorContainer.investmentMinimums.editingInvestmentMinimums,
    loading: state.adviserProfileEditorContainer.investmentMinimums.loadingInvestmentMinimums,
    formIsValid: state.adviserProfileEditorContainer.investmentMinimums.isInvalid.formIsValid,
    validationstate: state.adviserProfileEditorContainer.investmentMinimums.isInvalid,
    submitting: state.adviserProfileEditorContainer.investmentMinimums.updatingInvestmentMinimums
  }
}

const mapDispatchToProps = (dispatch) => {
  const { edit, set } = actions
  return bindActionCreators({
    startEditing: edit.start,
    stopEditing: edit.stop,
    setMinimumLumpSum: set.minimumLumpSum,
    setMinimumMonthlyDebitOrder: set.minimumMonthlyDebitOrder,
    setAllowUnsureInvestors: set.allowUnsureInvestors,
    cancelEditingAdviserProfileInvestmentMinimums: edit.cancel,
    minimumLumpSumSelected: minimumLumpSumSelected,
    minimumMonthlyDebitOrderSelected: minimumMonthlyDebitOrderSelected
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (AdviserProfileInvestmentMinimumsEditor))
